<template>
  <el-scrollbar v-if="!isMobile()">
    <div :class="['quick-phrase', isMobile() ? 'h5' : 'pc']">
      <div class="quick-phrase__item" v-for="item in phraseList" :key="item.id" @click="handlePhrase(item)">
        <div v-if="item.highLight === 1" class="active"></div>
        {{ item.name }}
      </div>
    </div>
  </el-scrollbar>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import { isMobile } from '@/utils/index'
const props = defineProps({
  phraseList: { type: Array, default: () => [] } //快捷短语
})
const emit = defineEmits(['quickPhrase'])
// 快捷短语点击
const handlePhrase = (data) => {
  emit('quickPhrase', { ...data, menuType: 2 })
}
</script>
<style lang="less" scoped>
.quick-phrase {
  display: flex;
  align-items: center;
  &.pc {
    height: 40px;
    border-bottom: 1px solid #eee;
    padding: 0 10px;
    box-sizing: border-box;
  }
  &.h5 {
    padding: 10px 10px 0;
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.2);
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #ededed;
      border-radius: 10px;
    }
  }
  &__item {
    font-size: 12px;
    color: #333333;
    padding: 4px 8px;
    border: 1px solid #3571f0;
    border-radius: 20px;
    cursor: pointer;
    box-sizing: border-box;
    background-color: #fff;
    white-space: nowrap;
    position: relative;
    .active {
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #3571f0;
      top: 0;
      right: 2px;
    }
    & + & {
      margin-left: 12px;
    }
  }
}
</style>
